import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import './css/Form.css'

import { handleSubmit } from './../helpers'

import {
  onChangeName, onChangeEmail, onChangeLink, onChangeAgree, onSendForm
} from './../actions/app'

const scrollToTest = () => {
  document.querySelector('h2').scrollIntoView({
    block: "start",
    behavior: "smooth"
  })
}

const Form = ({ form, onChangeName, onChangeEmail, onChangeLink, onChangeAgree, onSendForm }) => (
  <form onSubmit={handleSubmit}>
    <button onClick={scrollToTest} className="start_button">Start the Test</button>
    <h2>Fill in before start</h2>
    <label htmlFor="name" className={form.nameIsValid}>
      *Full Name
      <input type="text" defaultValue={ form.name } onChange={ onChangeName } autoComplete='name' id="name" placeholder="Full Name" />
    </label>
    <label htmlFor="email" className={form.emailIsValid}>
      *Email
      <input type="text" defaultValue={ form.email } onChange={ onChangeEmail } autoComplete='email' id="email" placeholder="Your email here…" />
    </label>
    <label htmlFor="portfolio0" className={form.portfolio0IsValid}>
      *Portfolio Links
      <input type="text" defaultValue={ form.portfolio0 } onChange={ onChangeLink } id="portfolio0" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="portfolio1" className={form.portfolio1IsValid}>
      Portfolio Links
      <input type="text" defaultValue={ form.portfolio1 } onChange={ onChangeLink } id="portfolio1" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="portfolio2" className={form.portfolio1IsValid}>
      Portfolio Links
      <input type="text" defaultValue={ form.portfolio2 } onChange={ onChangeLink } id="portfolio2" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
    </label>
    <label htmlFor="agree" onClick={ () => onChangeAgree(!form.checked) } className={form.checked ? 'checked' : ''}>
      I agree that i will do this test on the mandatory time frame, and I will not try to cheat it.
      <input type="checkbox" />
    </label>
    <button disabled={form.disabled} onClick={onSendForm}>Send information and Start the Test</button>
  </form>
)


const mapStateToProps = ({ app: { form } }) => ({
  form
})
const mapDispatchToProps = dispatch => bindActionCreators({
  onChangeName, onChangeEmail, onChangeLink, onChangeAgree, onSendForm
}, dispatch)

export default connect(
  mapStateToProps, mapDispatchToProps
)(Form)


// import React from 'react'
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'

// import './css/Form.css'

// import { handleSubmit } from './../helpers'

// import {
//   onChangeName
// } from './../actions/app'

// const scrollToTest = () => {
//   document.querySelector('form').scrollIntoView({
//     block: "start",
//     behavior: "smooth"
//   })
// }

// class Form extends React.Component {
  
//   constructor(props) {
//     super(props)
//     this.state = {
//       disabled: true,
//       ...props.form,
//     }
//   }
//   componentWillReceiveProps({ form }){
//     // this.setState({
//     //   ...form
//     // })
//   }
//   onChangeName = (e) => {
//     this.setState({
//       name: e.target.value
//     })
//   }
//   render(){
//     return (<form onSubmit={handleSubmit}>
//       <button onClick={scrollToTest} className="start_button">Start the Test</button>
//       <h2>Fill in before start</h2>
//       <label htmlFor="name">
//         *Full Name
//         <input type="text" defaultValue={ this.state.name } onChange={this.onChangeName} autoComplete='name' id="name" placeholder="Full Name" />
//       </label>
//       <label htmlFor="email">
//         *Email
//         <input type="text" value={ this.state.email } autoComplete='email' id="email" placeholder="Your email here…" />
//       </label>
//       <label htmlFor="portfolio0">
//         *Portfolio Links
//         <input type="text" value={ this.state.portfolio0 } id="portfolio0" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
//       </label>
//       <label htmlFor="portfolio1">
//         Portfolio Links
//         <input type="text" value={ this.state.portfolio1 } id="portfolio1" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
//       </label>
//       <label htmlFor="portfolio2">
//         Portfolio Links
//         <input type="text" value={ this.state.portfolio2 } id="portfolio2" placeholder="Google Drive, Yandex Disk, Dropbox, Url…" />
//       </label>
//       <label htmlFor="agree" className={this.state.checked ? 'checked' : ''}>
//         I agree that i will do this test on the mandatory time frame, and I will not try to cheat it.
//         <input type="checkbox"/>
//       </label>
//       <button disabled={this.state.disabled} >Send information and Start the Test</button>
//     </form>)
//   }
// }

// const mapStateToProps = ({ app: { form } }) => ({
//   form
// })
// const mapDispatchToProps = dispatch => bindActionCreators({
//   onChangeName
// }, dispatch)

// export default connect(
//   mapStateToProps, mapDispatchToProps
// )(Form)



// WEBPACK FOOTER //
// ./src/containers/Form.js